module.exports = __webpack_public_path__ + "media/images/groove-e565b57c0416de2e980f1ea34a3146ce.svg";